import { type Locale, setDefaultOptions } from "date-fns";

export function initDateFns(locale: Locale) {
    setDefaultOptions({ locale, weekStartsOn: 1, firstWeekContainsDate: 4 });
}
